import React, { useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import { searchProducts } from "../../../http/productAPI";
import { saveProductsAction } from '../../../store/products/actions';
import styles from "./MySearch.module.scss";
import { useNavigate } from 'react-router-dom';
import { NavLink } from "react-router-dom";

const SearchForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [value, setValue] = useState("");
    const [allProducts, setAllProducts] = useState([])
    const [dropItems, setDropItems] = useState([]);
    const [typingTimeout, setTypingTimeout] = useState(null);
    const [loading, setLoading] = useState(false)
    const [productNotFound, setProductNotFound] = useState(false)

    const handleChange = (val) => {
        setLoading(true)
        setValue(val);
        if (typingTimeout) clearTimeout(typingTimeout);
        const timeout = setTimeout(() => {
            trySearch(val);
            setLoading(false)
        }, 3000);

        setTypingTimeout(timeout);
    };

    const trySearch = async (val) => {
        if (!val.trim()) {
            setDropItems([]);
            return;
        }

        const result = await searchProducts(val);
        const data = result.data;
        if (data.length > 0) {
            setAllProducts(data)
            setDropItems(data);
            setProductNotFound(false)
        } else {
            setProductNotFound(true)
        }
    };

    const redirectToProducts = () => {
        dispatch(saveProductsAction(allProducts));
        navigate("/products");
        setDropItems([])
    }
    const clearDropItems = () => {
        setDropItems([])
    }

    const cleareSearch = () => {
        setValue("")
        setDropItems([])
        setAllProducts([])
        setProductNotFound(false)
    }

    return (
        <div className={styles.searchWrapper}>
            <div className={styles.searchContainer}>
                <input
                    type="text"
                    className={styles.searchInput}
                    placeholder="Пошук"
                    value={value}
                    onChange={(e) => handleChange(e.target.value)}
                />
                {loading ?
                    <CustomLoader></CustomLoader> :
                    value ? <button className={styles.searchButton} onClick={() => cleareSearch()}>X</button>
                        :
                        <button className={styles.searchButton}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" className={styles.search_loop} height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                            </svg>
                        </button>
                }
            </div>

            {dropItems.length > 0 && (
                <div className={styles.dropdown}>
                    {dropItems.map((item) => (
                        <NavLink to={`/products/item/${item._id}`} onClick={() => clearDropItems()}>
                            <span key={item.id} className={styles.dropdownItem}>
                                {item.name} <br></br> <b>{item.currentPrice}</b> грн
                            </span>
                        </NavLink>
                    ))}
                    <hr></hr>
                    <div onClick={() => redirectToProducts()} className={styles.dropdownItem}>
                        Показати більше
                    </div>
                </div>
            )}
            {productNotFound &&
                <div className={styles.dropdown}>
                    <div className={styles.dropdownItem}>
                        Товар не знайдено
                    </div>
                </div>
            }
        </div>
    );
};


const CustomLoader = () => {
    return (
        <div className="spinner-border" role="status">
        </div>
    )
}

export default SearchForm;
